import { type TextareaHTMLAttributes, forwardRef } from "react";
import { cn } from "../cn";

export interface TextareaProps
  extends TextareaHTMLAttributes<HTMLTextAreaElement> {}

/**
 * Multi-line text input primitive. Same form-agnostic contract as `Input`:
 * ref-forwarding, controlled/uncontrolled, no built-in label/error/validation
 * (deferred to a future `Field` wrapper). Fixed `rows` for now — auto-grow is
 * a nice-to-have follow-up, not required for the initial composer use case.
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, rows = 3, ...props }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(
        "w-full resize-none rounded-xl border border-input bg-surface px-3 py-2 text-sm text-foreground shadow-sm transition-colors placeholder:text-muted-foreground hover:bg-muted/50 focus-visible:border-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/15 disabled:pointer-events-none disabled:opacity-50 aria-[invalid=true]:border-destructive",
        className,
      )}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";
